import React from 'react';
import { ResourceField, ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { Armazem } from '../../types/estoque';
import { armazensService, enderecosService } from '../../services';
import { makeOptionLoader } from '../../utils/optionLoaders';

const fields: ResourceField<Armazem>[] = [
  { name: 'nome', label: 'Nome', required: true },
  { name: 'descricao', label: 'Descrição' },
  {
    name: 'endereco',
    label: 'Endereço',
    type: 'async-select',
    valueType: 'number',
    loadOptions: makeOptionLoader(
      enderecosService.list,
      (item: any) => {
        const partes = [item.logradouro, item.bairro, item.cidade_nome, item.cep].filter(Boolean);
        return partes.length ? partes.join(', ') : `Endereço #${item.id}`;
      },
    ),
  },
  {
    name: 'ativo',
    label: 'Ativo',
    render: ({ value, onChange }) => (
      <div className="form-check form-switch">
        <input
          id="armazem-ativo"
          className="form-check-input"
          type="checkbox"
          checked={value !== false}
          onChange={(e) => onChange(e.target.checked)}
        />
        <label className="form-check-label" htmlFor="armazem-ativo">
          Armazém ativo
        </label>
      </div>
    ),
  },
];

export const ArmazensFormPage: React.FC = () => (
  <ResourceFormPage
    title="Armazém"
    description="Cadastre armazéns para vincular saldos e movimentações."
    fields={fields}
    service={armazensService}
    redirectPath="/admin/parametros/armazens"
    cancelPath="/admin/parametros/armazens"
    initialValues={{ ativo: true }}
  />
);
